import { css } from "@emotion/react";

export const root = (isCollapsed: boolean) => css`
  display: flex;
  justify-content: start;
  flex-direction: column;
  align-items: center;
  padding: ${isCollapsed ? "36px 8px" : "36px 14px"};
  min-width: ${isCollapsed ? "70px" : "250px"};
  width: ${isCollapsed ? "70px" : "250px"};
  height: 100vh;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  overflow-x: visible;
  z-index: 11;
  transition: width 0.25s ease, min-width 0.25s ease, padding 0.25s ease;

  @media (max-width: 1264px) {
    display: none;
  }
`;

export const collapseButton = css`
  position: absolute;
  top: 20px;
  right: 12px;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid #dbeafe;
  background: #ffffff;
  color: #001740;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);

  &:hover {
    background: #f2f6ff;
  }
`;

export const nav = (isCollapsed: boolean) => css`
  width: 100%;
  margin-top: ${isCollapsed ? "42px" : "0"};
`;